import $ from 'jquery';
import 'slick-carousel';

export default function employeeSlider() {
    const sliders = $('.js-employee-slider');
    if (!sliders.length) {
        return;
    }

    try {
        sliders.each(function(index, slider) {
            $(slider).slick({
                rows: 0,
                infinite: false,
                arrows: false,
                dots: true,
                swipeToSlide: true,
                slidesToShow: 1,
                autoPlay: true,
                autoplaySpeed: 3000,
                pauseOnHover: true,
            });
        })
    } catch (e) {

    }
}